/**
 * Heading Blend — Theme Customizer Integration
 * Hot-reload de estilos cuando se editan secciones en el editor
 */
(function () {
  'use strict';

  if (!(window.Shopify && window.Shopify.designMode)) return;

  /* Cuando el Theme Editor recarga una sección, forzar repaint
     para que mix-blend-mode y las CSS variables se actualicen */
  function refreshBlend() {
    document.querySelectorAll('.blend-active').forEach(function (el) {
      el.style.display = 'none';
      el.offsetHeight; /* forzar reflow */
      el.style.display = '';
    });
  }

  document.addEventListener('shopify:section:load', refreshBlend);
  document.addEventListener('shopify:section:reorder', refreshBlend);
})();
